import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { Big } = Util;

import XtSvg from "@/components/Xt/Svg";
import Currency from "components/Pages/Finance/_cmpt/Currency";
import Sub from "./sub";
import cx from "classnames";
import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
// import icon404 from "@/assets/images/common/icon404.png";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import getProductDefaultSelect from "components/Pages/Finance/_hook/getProductDefaultSelect";

export default observer(({ data, rowCls }) => {
  const t = useTranslation();
  const { finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    let apyMax = 0;
    let flexible = false;

    data.productCollections.map((categoryObj) => {
      const selectProduct = getProductDefaultSelect(categoryObj.financialProducts);
      let _apyMax = 0;
      selectProduct.apyList &&
        selectProduct.apyList.map((apyObj) => {
          apyObj.annualized > _apyMax && (_apyMax = apyObj.annualized);
        });
      _apyMax > apyMax && (apyMax = _apyMax);

      if (!flexible) {
        for (let i = 0; i < categoryObj.financialProducts.length; i++) {
          if (categoryObj.financialProducts[i].productType === "DEMAND_SAVING") {
            flexible = true;
            break;
          }
        }
      }

      /*
      categoryObj.financialProducts.map((productObj) => {
        productObj.apyList && productObj.apyList.map((apyObj) => {
          apyObj.annualized > apyMax && (apyMax = apyObj.annualized);
        });
        if (productObj.productType === "DEMAND_SAVING") flexible = true;
      });
       */
    });

    const convertData = {
      //币种，譬如：usdt
      currency: data.groupTag,
      apy: Big(apyMax).toFixed(2) + "%",
      duration: flexible ? t("finance.flexibleFixed") : t("finance.fixed"),
    };

    return convertData;
  }, [data]);

  const [isExpand, setIsExpand] = useState(false);

  const onCollapse = useCallback(() => {
    setIsExpand(!isExpand);
  }, [isExpand]);

  return (
    <div className={cx(stylesProducts.tableRow, styles.main)}>
      <div className={cx(stylesProducts.tableRowLine, rowCls)}>
        <div>
          <Currency data={selfData.currency} className={stylesProducts.currency} />
        </div>
        <div>
          <span className={stylesProducts.apy}>{selfData.apy}</span>
        </div>
        <div>
          <span>{t("finance.multiple")}</span>
        </div>
        <div>
          <span>{selfData.duration}</span>
        </div>
        <div>
          <button className={cx("btnTxt", stylesProducts.btn)} onClick={onCollapse}>
            <span>{isExpand ? t("finance.collapse") : t("finance.subscribe")}</span>
            <XtSvg icon="arr-left" style={{ transform: isExpand ? "rotateZ(90deg)" : "rotateZ(-90deg)" }} />
          </button>
        </div>
      </div>

      {isExpand && data.productCollections.map((data) => <Sub key={data.category} data={data} rowCls={rowCls} />)}
    </div>
  );
});
